import { BaseContext } from "../../../utils/basecontext";
import { UIComponentHandler, UIComponentImpl, UIComponentProps, UIComponentState, UIDataModel } from "../uicomponent";
import { UIComponentCSSStyle } from "../uicomponentcss";
import { UIComponentView } from "../uicomponentview";
import { SwitchCSSStyle } from "./switchcss";
import { SwitchView } from "./switchview";

export interface SwitchProps extends UIComponentProps
{
    style: SwitchCSSStyle;
    isChecked: boolean; 
    onChange(isChecked:boolean):void;

}
export interface SwitchState extends UIComponentState
{
    style: SwitchCSSStyle;
    isChecked: boolean; 

}

export interface SwitchHandler extends UIComponentHandler
{
    onChange(isChecked:boolean):void;
}

export class SwitchComponent extends UIComponentImpl<SwitchProps, SwitchState, UIDataModel>
{
    

    constructor(props:SwitchProps){
        super(props);

        this.state = {style: props.style, isChecked: props.isChecked};

        
    }
    // constructor(props: SwitchProps)
    // {
    //     super(props);

    //     this.state = {style: props.style, isSelected:props.isSelected};
    // }
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new SwitchView(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return this.state.style;
    }

    UNSAFE_componentWillReceiveProps(nextProps: SwitchProps)
    {
        this.setState({ style: nextProps.style, isChecked: nextProps.isChecked});
    }
    isChecked():boolean{
        return this.state.isChecked;
    }

    onChange(isCheckedin:boolean):void
    {
        console.log("before click:",this.state.isChecked);
        this.setState({isChecked:isCheckedin});
        console.log("after click:",isCheckedin);
        this.props.onChange(isCheckedin);
 
    }
    updateShuffle():void{
        console.log("updateShuffle() invoked ",!this.state.isChecked);
        this.setState({isChecked:!this.state.isChecked});
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/switch/switchcomponent.tsx